import { VariantProps } from "class-variance-authority";
import React, { LegacyRef } from "react";
import { buttonCva } from "..";
import styles from "../button.module.scss";
export interface ButtonProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof buttonCva> {
  /**
   * Text for the button
   *
   * @default null
   */
  children?: React.ReactNode;
  /**
   * Optional click handler
   */
  onClick?: (e?: any) => void;
  /**
   * The button type. The default is "submit" because most browsers have this default.
   *
   * @default "submit"
   */
  type?: "submit" | "button" | "reset" | undefined;
  /**
   * The button ref.
   */
  ref?: LegacyRef<HTMLDivElement>;
}

/**
 * Primary UI component for user interaction
 */
export default function ButtonDiv({
  children,
  className,
  buttonStyle,
  block,
  raised = true,
  iconed = false,
  fab = false,
  bordered = false,
  disabled,
  size,
  type = "submit",
  ...props
}: ButtonProps) {
  return (
    <div
      className={`${buttonCva({
        buttonStyle,
        block,
        iconed,
        fab,
        raised,
        bordered,
        disabled,
        size,
        class: className,
      })} ${styles.buttonDiv}`}
      {...props}
    >
      {children}
    </div>
  );
}
export { ButtonDiv };
